import _DTO from "./_DTO";
import DeviceAccessoryDTO from './DeviceAccessoryDTO';

export default class PowerSupplyDTO extends _DTO {

  constructor(device) {
    super();
    this.id = device.id;
    this.accessories = PowerSupplyDTO.getMappedOrDefault(device, 'accessories', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.auxiliaries = PowerSupplyDTO.getMappedOrDefault(device, 'auxiliaries', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.sensors = PowerSupplyDTO.getMappedOrDefault(device, 'sensors', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.spareParts = PowerSupplyDTO.getMappedOrDefault(device, 'spareParts', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));
    this.options = PowerSupplyDTO.getMappedOrDefault(device, 'options', [], data => (data || []).map(d => new DeviceAccessoryDTO(d)));

  }
}
